<div class="dsi-wrapper" [class.is-open]="isOpen" [class.is-disabled]="disabled">

  <!-- Label -->
  <label *ngIf="label" class="dsi-label">
    {{ label }}
    <span *ngIf="control?.hasValidator?.(required_validator)" class="text-red-600">*</span>
  </label>

  <!-- Input Field -->
  <div #inputContainer class="dsi-input-container" (click)="toggleDropdown()">
    <svg class="dsi-search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#666666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M21 21L16.65 16.65" stroke="#666666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <input
      #searchInput
      type="text"
      class="dsi-input"
      [class.dsi-input--has-value]="searchText"
      [(ngModel)]="searchText"
      (input)="onSearchInput()"
      (click)="$event.stopPropagation(); openDropdown()"
      (keydown)="onKeyDown($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      autocomplete="off"
    />
  </div>

</div>

<!-- Dropdown portal template — appended to document.body at runtime -->
<ng-template #dropdownTpl>
  <div class="dsi-dropdown" [ngStyle]="dropdownStyle" (scroll)="onDropdownScroll($event)">

    <div
      *ngFor="let option of filteredOptions"
      class="dsi-option"
      (mousedown)="$event.preventDefault(); selectOption(option)"
    >
      <span class="dsi-option-primary">{{ option[displayKey] }}</span>
      <span *ngIf="subDisplayKey && option[subDisplayKey]" class="dsi-option-secondary">
        {{ option[subDisplayKey] }}
      </span>
    </div>

    <div *ngIf="loading" class="dsi-loading-row">
      <div class="dsi-spinner"></div>
    </div>

    <div *ngIf="!loading && filteredOptions.length === 0" class="dsi-empty">
      No results found
    </div>

  </div>
</ng-template>

<!-- Validation error -->
<div *ngIf="control && control.errors && (control.dirty || control.touched)">
  <p class="text-red-500 text-sm mt-1" *ngIf="control.errors['required']">
    Please select a {{ label || 'value' }}.
  </p>
</div>
